var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1009_18030",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.5684,
    height: 24.5684,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1009_18030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1682 15.8401L16.3595 12.8337C16.0273 12.4781 15.5743 12.2842 15.1213 12.2842C14.6381 12.2842 14.2153 12.4781 13.8831 12.8337C13.5509 13.1893 13.3697 13.6742 13.3697 14.1591C13.3697 14.5794 13.4905 14.9673 13.7019 15.2906H6.6954C5.72899 15.2906 4.91357 16.1311 4.91357 17.1979C4.91357 18.2323 5.69879 19.1051 6.6954 19.1051H13.6717C13.1583 19.8487 13.2187 20.8831 13.8529 21.562C14.1851 21.9176 14.6381 22.1115 15.0911 22.1115C15.5743 22.1115 15.9971 21.9176 16.3293 21.562L19.138 18.5556C19.4702 18.2 19.6514 17.7474 19.6514 17.2302C19.6816 16.6806 19.5004 16.1957 19.1682 15.8401Z",
    fill: "#848FAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4002 8.72822L8.20883 11.7346C8.54104 12.0902 8.99404 12.2842 9.44705 12.2842C9.93026 12.2842 10.3531 12.0902 10.6853 11.7346C11.0175 11.379 11.1987 10.8941 11.1987 10.4092C11.1987 9.98897 11.0779 9.60105 10.8665 9.27778H17.873C18.8394 9.27778 19.6548 8.43728 19.6548 7.37049C19.6548 6.33603 18.8696 5.46321 17.873 5.46321H10.8967C11.4101 4.71969 11.3497 3.68523 10.7155 3.00637C10.3833 2.65077 9.93026 2.45681 9.47725 2.45681C8.99404 2.45681 8.57124 2.65077 8.23903 3.00637L5.4304 6.01277C5.09819 6.36836 4.91699 6.82094 4.91699 7.33817C4.88679 7.88772 5.06799 8.37263 5.4002 8.72822Z",
    fill: "#848FAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferItem);
export default __webpack_public_path__ + "static/media/transferItem.2cc9c5ede98ff1dab6b59c03f5742a18.svg";
export { ForwardRef as ReactComponent };